import './App.css';
import LOGO from './assets/dante-elektro-logo.png';
import COMPANY_NAME_LOGO from './assets/company-name.png';
import PHOTO_1 from './assets/1.png';
import PHOTO_2 from './assets/2.png';
import PHOTO_3 from './assets/3.png';
import PHOTO_4 from './assets/4.png';
import PHOTO_5 from './assets/5.png';
import PHOTO_6 from './assets/6.png';

function App() {
  return (
    <div className='app'>
      <header>
        <img src={LOGO} alt='logo' className='logo'/>
        <div className='header-text'>
          <h2>PR POSTAVLJANJE ELEKTRIČNIH INSTALACIJA</h2>
          <img src={COMPANY_NAME_LOGO} alt='company-name-logo' className='company-name-logo' />
          <h3>DANIEL TOŠIĆ spec.ing.el. <span>063/511-262</span></h3>
          <h3>pib: 112189576 adresa: 16 divizije 164a, Kula 25230</h3>
          <h3>pon-petak / 7-15h <a href='mailto:webdesign@example.com'>dante.elektronika@gmail.com</a></h3>
        </div>
      </header>
      <div>
        <ul className='list'>
          <li>- PROJEKTOVANJE I IZRDADA ELEKTRO-ORMANA SVIH NAMENA.</li>
          <li>- AUTOMATIZACIJA POGONA U SILOSIMA, FARMAMA.</li>
          <li>- AUTOMATIZACIJA KOTLOVSKIH POSTROJENJA NA PELET, SEČKU, GAS.</li>
          <li>- PUŠTANJE RADNIH MAŠINA, MOTORA U POGON.</li>
          <li>- ELEKTROINSTALACIJE U POGONIMA, ZGRADAMA, KUĆAMA.</li>
          <li>- SERVIS KOTLOVA NA PELET, ELEKTRO MAŠINA.</li>
        </ul>
      </div>
      <div className='photos'>
        <div className='first-row'>
          <img src={PHOTO_1} alt='photo-1' />
          <img src={PHOTO_2} alt='photo-2' />
          <img src={PHOTO_3} alt='photo-3' />
        </div>
        <div className='second-row'>
          <img src={PHOTO_4} alt='photo-4' className='photo-4' />
          <img src={PHOTO_5} alt='photo-5' />
          <img src={PHOTO_6} alt='photo-6' className='photo-6' />
        </div>
      </div>
    </div>
  );
}

export default App;
